import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlag } from "@fortawesome/free-solid-svg-icons";
import { utils } from "../../../../utils/utils";

const STATUS_ACTIONS = {
  2: [{ label: "Start Detailing", nextStatus: 3, color: "success" }],
  3: [{ label: "Send to Checker", nextStatus: 4, color: "warning" }],
  4: [{ label: "Start Checking", nextStatus: 5, color: "success" }],
  5: [{ label: "Send to Scrubbing", nextStatus: 8, color: "success" }],
  8: [{ label: "Start Scrubbing", nextStatus: 9, color: "success" }],
  9: [{ label: "Send to Look Over", nextStatus: 10, color: "success" }],
  10: [{ label: "Start Look Over", nextStatus: 11, color: "success" }],
  11: [
    { label: "Send to Scrubbing", nextStatus: 8, color: "warning" },
    { label: "Ready for Review", nextStatus: 6, color: "success" },
  ],
};

// Inner cell content — reused by both the sortable row and the DragOverlay clone.
export const SequenceRowCells = ({
  sequence,
  isTop,
  onStatusAction,
  onDetails,
}) => {
  const detailer = sequence.detailer
    ? `${sequence.detailer.firstName} ${sequence.detailer.lastName}`
    : "-";
  const checker = sequence.checker
    ? `${sequence.checker.firstName} ${sequence.checker.lastName}`
    : "-";
  const actions = STATUS_ACTIONS[+sequence.sequenceStatusId] || [];

  return (
    <>
      <td>
        {isTop && (
          <FontAwesomeIcon
            icon={faFlag}
            className="text-warning mr-1"
            title="Top Priority"
          />
        )}
        {sequence.job?.jobNumber || "-"}
      </td>
      <td>{sequence.job?.customer?.name || "-"}</td>
      <td>{sequence.description || "-"}</td>
      <td>
        {sequence.revisionDate ? utils.formatDate(sequence.revisionDate) : "-"}
      </td>
      <td>{sequence.notes || "-"}</td>
      <td>{detailer}</td>
      <td>{checker}</td>
      <td
        className="text-center p-0"
        onPointerDown={(e) => e.stopPropagation()}
      >
        <div className="d-flex flex-wrap gap-1 justify-content-center">
          {actions.map(({ label, nextStatus, color }) => (
            <Button
              key={nextStatus}
              className="btn-sm rounded px-1 py-0 mr-1 my-2 mb-0"
              color={color}
              onClick={() =>
                onStatusAction && onStatusAction(sequence, nextStatus)
              }
            >
              {label}
            </Button>
          ))}
          <Button
            className="btn-sm rounded px-1 py-0 my-2"
            color="primary"
            onClick={() => onDetails && onDetails(sequence)}
          >
            See Job Details
          </Button>
        </div>
      </td>
    </>
  );
};

// Sortable wrapper — attaches dnd-kit to the <tr> and hides it while DragOverlay is active.
const DraggableSequenceRow = ({
  sequence,
  isTop,
  onStatusAction,
  onDetails,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: sequence.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    // Hide original row while dragging — DragOverlay renders the visual clone.
    opacity: isDragging ? 0 : 1,
    cursor: "grab",
    backgroundColor: isTop ? "#fff3cd" : undefined,
    borderLeft: isTop ? "3px solid #ffc107" : "3px solid transparent",
  };

  return (
    <tr ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <SequenceRowCells
        sequence={sequence}
        isTop={isTop}
        onStatusAction={onStatusAction}
        onDetails={onDetails}
      />
    </tr>
  );
};

export default DraggableSequenceRow;
